import { CMS_API_SUCCESS, CMS_API_FAILURE, CMS_API_FETCHING, CMS_API_FILE_NOT_FOUND } from '../actions'
import tempState from '../helper/initial-state'

export default (state = tempState, action) => {
  switch (action.type) {
    case CMS_API_FETCHING:
      return { ...state, isFetching: true }
    case CMS_API_SUCCESS:
      return { ...state, isFetching: false, ...action.data }
    case CMS_API_FAILURE:
      return { ...state, ...action.data }
    case CMS_API_FILE_NOT_FOUND:
      return { ...state, ...action.data }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./services/cms-state/reducer/index.js